import { render, staticRenderFns } from "./LeaderCard.vue?vue&type=template&id=80414518&scoped=true&"
import script from "./LeaderCard.vue?vue&type=script&lang=js&"
export * from "./LeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./LeaderCard.vue?vue&type=style&index=0&id=80414518&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80414518",
  null
  
)

export default component.exports